import {useCallback, useContext, useEffect, useState} from "react";
import {Tab, Tabs} from "react-bootstrap";
import {useSearchParams} from "react-router-dom";
import UserManagement from "./Components/UserManagement";
import PointsManagement from "./Components/PointsManagement";
import MainPanelHeader from "../../layouts/mainPanelHeader";
import PanelLeftContent from "../../layouts/mainPanel/PanelLeftContent";
import "./style.scss";
import ContentManagment from "./Components/ContentManagment";
import {get} from "../../controlers/global/ConfigRequest";
import {COMPANY_CLUBS_SUMMARY} from "../../helperData/ApiAddress";
import {useTranslation} from "react-i18next";
import {GlobalStateContext} from "../../layouts/GlobalStates";
import ParticipationSidebar from "./ParticipationSidebar";
import {isParticipationEnabled} from "../../helperData/organizationSidebar";

const PARTICIPATION_TAB_KEYS = ["1", "3", "4"];

export default function CustomerClub() {
  const {auth} = useContext(GlobalStateContext)
  const [searchParams, setSearchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get("tab");
    return tab === "points" || searchParams.has("section") ? "4" : "1";
  });
  const [chartSummary, setChartSummary] = useState(null);
  const {t} = useTranslation();
  const participationEnabled = isParticipationEnabled(auth);

  useEffect(() => {
    get(COMPANY_CLUBS_SUMMARY)
      .then((response) => setChartSummary(response || {}))
      .catch(() => setChartSummary({}));
  }, []);

  useEffect(() => {
    if (!participationEnabled) {
      return;
    }
    if (searchParams.get("tab") === "members") {
      setActiveTab("1");
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete("tab");
      nextParams.delete("section");
      setSearchParams(nextParams, {replace: true});
      return;
    }
    if (searchParams.get("tab") === "points") {
      setActiveTab("4");
      const nextParams = new URLSearchParams(searchParams);
      nextParams.delete("tab");
      if (!nextParams.has("section")) nextParams.set("section", "overview");
      setSearchParams(nextParams, {replace: true});
      return;
    }
    if (!PARTICIPATION_TAB_KEYS.includes(activeTab)) {
      setActiveTab(PARTICIPATION_TAB_KEYS[0]);
    }
  }, [searchParams, setSearchParams, participationEnabled, activeTab]);

  const contentTab = useCallback(() => {
    if (!participationEnabled) {
      return null;
    }
    return (
      <Tab
        eventKey="3"
        className="panel_tab_item"
        title={t("Organizational.CustomerClub.Media&AdvertismentManagment.Tab")}
      >
        <ContentManagment activeTab={activeTab}/>
      </Tab>
    )
  }, [activeTab, participationEnabled, t])

  const pointsTab = useCallback(() => {
    if (!participationEnabled) {
      return null;
    }
    return (
      <Tab
        eventKey="4"
        className="panel_tab_item"
        title={t("Organizational.CustomerClub.PointsManagement.Tab")}
      >
        <PointsManagement activeTab={activeTab}/>
      </Tab>
    )
  }, [activeTab, participationEnabled, t])

  const memberTab = useCallback(() => {
    if (!participationEnabled) {
      return null;
    }
    return (
      <Tab
        eventKey="1"
        className="panel_tab_item"
        title={t("Organizational.CustomerClub.MemberManagment.Tab")}
      >
        <UserManagement activeTab={activeTab}/>
      </Tab>
    )
  }, [activeTab, participationEnabled, t])

  return (
    <div id="customer-club" className="main_panel_box customer-club">
      <MainPanelHeader/>
      <div className="main_panel_content">
        <div className="right_content main_box">
          <div className="tab-section">
            <Tabs
              activeKey={activeTab}
              transition={false}
              className="panel_tab"
              onSelect={(e) => setActiveTab(e)}
            >
              {memberTab()}
              {contentTab()}
              {pointsTab()}
            </Tabs>
          </div>
        </div>
        <PanelLeftContent>
          <ParticipationSidebar summary={chartSummary} />
        </PanelLeftContent>
      </div>
    </div>
  );
}
